import React, { Component } from "react";
import MiniPopup from "../../Modals and Popovers/MiniPopup";
import { makeColorInterfaceButton } from "./makeColorInterfaceButton";

// ce fichier est appelé par Deducer, et va servir à créer des boutons gérantrelatifs aux règles présentes dans l'exo en cours :
// a) le bouton pour grouper ou dégrouper les règles

class DeductionButtonMaker extends Component {
  render() {
    // section 0 : choix de couleur du site
    let colorChoiceClassName = "icon pointable fa-solid ",
      colorChoiceClassMayBeHidden = "hiddenSustainable";

    if (
      !this.props.valueInference.booleansOptionsAboutInferences.boolColorChoice
    ) {
      colorChoiceClassName += "fa-palette ";
      colorChoiceClassMayBeHidden = "hiddenSustainable";
    } else if (
      this.props.valueInference.booleansOptionsAboutInferences.boolColorChoice
    ) {
      colorChoiceClassName += "fa-brush ";
      colorChoiceClassMayBeHidden = "";
    }

    let colorChoiceWindowOpener = (
      <MiniPopup
        iconClass={colorChoiceClassName}
        text={"Cliquez pour ouvrir un choix de couleurs pour le site."}
        onClick={() =>
          this.props.valueInference.toggleOptionsAboutInferences("colorChoice")
        }
      />
    );

    let colorChoiceWindow = (
      <div id="colorChoicePopup" className={colorChoiceClassMayBeHidden}>
        Cliquez sur une couleur !
        <ul id="colorChoicePopupList">
          {[
            "Red",
            "Green",
            "Blue",
            "Black",
            "Pink",
            "Grey",
            "Yellow",
            "Orange",
            "Purple",
            "Cyan",
            "Olivegreen",
            "Slategray",
            "GradientOrangeRed",
            "GradientPurpleBlue",
            "GradientBlackRed",
            "GradientGreenYellow",
          ].map((color) =>
            makeColorInterfaceButton(color, () =>
              this.props.valueInference.toggleOptionsAboutInferences(color)
            )
          )}
        </ul>
      </div>
    );

    // section 1 : la détection des inférences compatibles
    let eyeOfCompatibleInferencesClassName = "icon pointable ";

    if (
      !this.props.valueInference.booleansOptionsAboutInferences
        .boolInferenceScanner
    ) {
      eyeOfCompatibleInferencesClassName += "fas fa-eye-slash ";
    } else if (
      this.props.valueInference.booleansOptionsAboutInferences
        .boolInferenceScanner
    ) {
      eyeOfCompatibleInferencesClassName += "fas fa-eye ";
    }

    let eyeOfCompatibleInferences = (
      <MiniPopup
        iconClass={eyeOfCompatibleInferencesClassName}
        text={
          "Cliquez pour activer/désactiver la détection automatique des inférences compatibles avec la règle en cours."
        }
        onClick={() =>
          this.props.valueInference.toggleOptionsAboutInferences(
            "InferenceScanner"
          )
        }
      />
    );

    // section 2 : sauter automatiquement la dernière étape de validation lorsque 2 arguments compatibles sont entrés (sauf pour les règles à choix)
    let finalCheckClassName = "icon pointable ";
    if (
      this.props.valueInference.booleansOptionsAboutInferences.boolFinalCheck
    ) {
      finalCheckClassName += "fas fa-check";
    } else if (
      !this.props.valueInference.booleansOptionsAboutInferences.boolFinalCheck
    ) {
      finalCheckClassName += "fas fa-check-double";
    }

    let finalCheck = (
      <MiniPopup
        iconClass={finalCheckClassName}
        text={
          "Cliquez pour activer/désactiver la tentative automatique de validation d'une règle au moment tous ses arguments ont été rentrés."
        }
        onClick={() =>
          this.props.valueInference.toggleOptionsAboutInferences("finalCheck")
        }
      />
    );

    // section 3 : activer/désactiver la version petit écran
    // let classNameMobileScreen = "icon ";
    // if (
    //   this.props.valueInference.booleansOptionsAboutInferences.boolMobileScreen
    // ) {
    //   classNameMobileScreen += "fa-solid fa-mobile";
    // } else if (
    //   !this.props.valueInference.booleansOptionsAboutInferences.boolMobileScreen
    // ) {
    //   classNameMobileScreen += "fa-solid fa-mobile-screen";
    // }

    // let mobileScreen = (
    //   <MiniPopup
    //     iconClass={classNameMobileScreen + " pointable"}
    //     text={
    //       "Cliquez pour activer/désactiver l'interface adaptée aux smartphones."
    //     }
    //     onClick={() =>
    //       this.props.valueInference.toggleOptionsAboutInferences("mobileScreen")
    //     }
    //   />
    // );

    // section 4 : activer/désactiver le debugger
    // let cameraOfTheDebuggerClassName = "hidden icon ";

    // if (
    //   !this.props.valueInference.booleansOptionsAboutInferences.boolDebugger
    // ) {
    //   cameraOfTheDebuggerClassName += "fas fa-video-slash";
    // } else if (
    //   this.props.valueInference.booleansOptionsAboutInferences.boolDebugger
    // ) {
    //   cameraOfTheDebuggerClassName += "fas fa-video ";
    // }

    // let cameraOfTheDebugger = (
    //   <MiniPopup
    //     iconClass={cameraOfTheDebuggerClassName + " pointable"}
    //     text={
    //       "Cliquez pour activer/désactiver l'outil de détection des bugs. Ça vous sera sûrement inutile !"
    //     }
    //     onClick={() =>
    //       this.props.valueInference.toggleOptionsAboutInferences("Debugger")
    //     }
    //   />
    // );

    // section 5 : grouper ou non les règles présentes
    let classNameRulesSortedOrNot = "icon pointable ";

    if (
      !this.props.valueInference.booleansOptionsAboutInferences.boolSortedRules
    ) {
      classNameRulesSortedOrNot += "fa-solid fa-border-all";
    } else if (
      this.props.valueInference.booleansOptionsAboutInferences.boolSortedRules
    ) {
      classNameRulesSortedOrNot += "fa-solid fa-border-none";
    }

    let rulesSortedOrNot = (
      <MiniPopup
        iconClass={classNameRulesSortedOrNot}
        text={"Cliquez ici pour regrouper ou dégroupez les règles."}
        onClick={() =>
          this.props.valueInference.toggleOptionsAboutInferences("sortedRules")
        }
      />
    );

    // section 6 : infos sur les touches du clavier

    let infosAboutKeybinding = (
      <MiniPopup
        iconClass={"icon fa-solid fa-keyboard"}
        text={
          "Note : Vous pouvez appuyer sur les flèches gauche et droite du clavier pour changer d'exercice."
        }
      />
    );

    return (
      <React.Fragment>
        {colorChoiceWindowOpener}
        {colorChoiceWindow}
        {rulesSortedOrNot}
        {eyeOfCompatibleInferences}
        {finalCheck}
        {/* {mobileScreen} */}
        {/* {cameraOfTheDebugger} */}
        {infosAboutKeybinding}
      </React.Fragment>
    );
  }
}
export default DeductionButtonMaker;



// WEBPACK FOOTER //
// ./src/components/Calcul Tools/Deducer Tools/DeductionButtonMaker.js